<template>
    <footer class="footer">
        <img src="assets/logo.png" class="footer-logo" alt="Logo">
        <img src="assets/icon-150.png" width="64" height="64" class="footer-icon" alt="Logo">

        <a class="footer-href" href="https://github.com/iarepandemonium">Originally designed by Pandetta.</a>
        <a class="footer-href" href="https://lynxplay.dev">Created by LynxPlay.</a>
        <p>© 2020 Copyright: <b>KnockturnMC Networks</b></p>
    </footer>
</template>

<script>
    export default {
        name: "LicenceFooter"
    }
</script>

<style scoped>
    /**
    Footer size and margin against the server info
     */
    .footer {
        height: 4rem;
        margin: 20% 0 0 0;
        background-color: #333d40;
        display: block;
    }

    /**
    All text should have a margin and float left.
    This only really applies to the copyright text.
     */
    .footer p {
        color: white;
        margin-top: 1.25rem;
        font-size: 0.8rem;
        float: left;
    }

    /**
    The hrefs (or contributer list) floats right and has the same margins as the copyright text
     */
    .footer a {
        color: white;
        font-size: 0.8rem;
        float: right;
        margin: 1.25rem 0.5rem;
    }

    /**
    Remove href decorations
     */
    .footer-href {
        display: block;
        color: white;
        text-decoration: none;
    }

    /**
    Remove href decorations
     */
    .footer-href:visited, .footer-href:hover, .footer-href:active {
        color: white;
    }

    /*
    The bigger logo for the footer including the server name. Floats left
     */
    .footer-logo {
        height: 4rem;
        float: left;
    }

    /**
    The smaller logo for the footer, only including the server icon
     */
    .footer-icon {
        float: left;
        display: none;
    }

    /**
    Swap big for small footer logo on less than 575 pixels
     */
    @media only screen and (max-width: 575px) {
        .footer-logo {
            display: none;
        }
        .footer-icon {
            display: block;
        }
    }

    /**
    Remove contributors on screen with less than 850 pixels.
     */
    @media only screen and (max-width: 905px) {
        .footer-href {
            display: none;
        }
        .footer p {
            float: right;
            padding-right: 3%;
        }
    }
</style>